import { render, staticRenderFns } from "./LSVCompactNew.vue?vue&type=template&id=4e1d969b&scoped=true"
import script from "./LSVCompactNew.vue?vue&type=script&lang=js"
export * from "./LSVCompactNew.vue?vue&type=script&lang=js"
import style0 from "./LSVCompactNew.vue?vue&type=style&index=0&id=4e1d969b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d969b",
  null
  
)

export default component.exports